module.exports = __webpack_public_path__ + "media/application/images/cyber-forum/close-bd201370d14862b7e25c2902c903a1c7.svg";